// ═══════════════════════════════════════
// EXPOSE FUNCTIONS IMMEDIATELY (CRITICAL)
// ═══════════════════════════════════════

window.selectBundle = function(c)       { console.warn('[Soneax] selectBundle stub — JS not ready yet', c); };
window.changeQty    = function(d)       { console.warn('[Soneax] changeQty stub — JS not ready yet', d); };
window.selectBonnet = function(c,i,b)   { console.warn('[Soneax] selectBonnet stub — JS not ready yet', c); };
window.selectColor  = function(c)       { console.warn('[Soneax] selectColor stub — JS not ready yet', c); };
window.toggleFaq    = function(el)      { console.warn('[Soneax] toggleFaq stub — JS not ready yet', el); };
window.carouselNext = function()        { console.warn('[Soneax] carouselNext stub — JS not ready yet'); };
window.carouselPrev = function()        { console.warn('[Soneax] carouselPrev stub — JS not ready yet'); };

// Wait for DOM (readyState check = safe with defer)
function safeInit() {
  try {
    initSoneax();
  } catch(err) {
    console.error('[Soneax] CRASH in initSoneax:', err);
  }
}

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', safeInit);
} else {
  safeInit();
}

function initSoneax() {

  // ═══════════════════════════════════════════════
  //   Soneax GoBrush Pro — PDP JavaScript
  // ═══════════════════════════════════════════════

  var bundleQty = 1;
        var bundleData = {
          black: { price: 39, original: 79, img: window.soneaxImages?.bundle_black || 'images/4.png' },
          white: { price: 39, original: 79, img: window.soneaxImages?.bundle_white || 'images/3.png' },
          pink:  { price: 45, original: 90, img: window.soneaxImages?.bundle_pink  || 'images/5.png' }
        };
        var currentBundle = 'black';

        function selectBundle(color) {
          window.selectBundle = selectBundle;
          currentBundle = color;
          var d = bundleData[color];
          var bi = document.getElementById('bundle-img');
          var bp = document.getElementById('bundle-price');
          var bo = document.getElementById('bundle-original');
          var bc = document.getElementById('bundle-cta-price');
          if (bi) bi.src = d.img;
          if (bp) bp.textContent = '£' + (d.price * bundleQty);
          if (bo) bo.textContent = '£' + d.original;
          if (bc) bc.textContent = '£' + (d.price * bundleQty);
          ['black','white','pink'].forEach(function(c) {
            var el = document.getElementById('bsel-' + c);
            if (!el) return;
            el.style.borderColor = c === color ? '#3B2A6D' : 'transparent';
            el.style.background  = c === color ? '#f0ebff' : (c === 'pink' ? '#fff5f8' : '#fafafa');
          });
        }

        function changeQty(delta) {
          window.changeQty = changeQty;
          bundleQty = Math.max(1, bundleQty + delta);
          document.getElementById('bundle-qty').textContent = bundleQty;
          var d = bundleData[currentBundle];
          var total = d.price * bundleQty;
          var bp = document.getElementById('bundle-price');
          var bc = document.getElementById('bundle-cta-price');
          if (bp) bp.textContent = '£' + total;
          if (bc) bc.textContent = '£' + total;
        }

    // ─────────────────────────────────────────────────────────

  function selectBonnet(color, img, btn) {
          window.selectBonnet = selectBonnet;
          // Update bonnet image
          var bonnetImg = document.getElementById('bonnet-img');
          if (bonnetImg) bonnetImg.src = img;
          // Update swatch border
          btn.parentElement.querySelectorAll('button').forEach(function(b) {
            b.style.borderColor = 'transparent';
          });
          btn.style.borderColor = '#3B2A6D';
          // Update ADD button variant ID
          var variantKey = 'bonnet_variant_' + color;
          var variantId  = window.soneaxImages && window.soneaxImages[variantKey];
          var addBtn = document.getElementById('bonnet-add-btn');
          if (addBtn && variantId) addBtn.setAttribute('data-variant-id', variantId);
        }

    // ─────────────────────────────────────────────────────────

  (function() {
    var track = document.getElementById('vid-track');
    var prev  = document.getElementById('vid-prev');
    var next  = document.getElementById('vid-next');
    if (track && prev && next) {
      next.onclick = function() { track.scrollBy({left:  212, behavior:'smooth'}); };
      prev.onclick = function() { track.scrollBy({left: -212, behavior:'smooth'}); };
    }
    document.querySelectorAll('.play-overlay').forEach(function(overlay) {
      var card  = overlay.parentElement;
      var video = card.querySelector('video');
      if (!video) return;
      // Clic overlay → play
      overlay.addEventListener('click', function() {
        overlay.style.display = 'none';
        video.play();
      });
      // Clic vidéo en cours → pause
      video.addEventListener('click', function() {
        if (!video.paused) {
          video.pause();
          overlay.style.display = 'flex';
        }
      });
      // Fin ou pause → réaffiche play
      video.addEventListener('ended', function() { overlay.style.display = 'flex'; });
      video.addEventListener('pause',  function() { overlay.style.display = 'flex'; });
    });
  })();

    // ─────────────────────────────────────────────────────────

  (function() {
    var wrap  = document.getElementById('tbl-wrap');
    var bar   = document.getElementById('tbl-scrollbar-wrap');
    var thumb = document.getElementById('tbl-thumb');
    if (!wrap || !bar || !thumb) return;

    function syncThumb() {
      var maxScroll = wrap.scrollWidth - wrap.clientWidth;
      if (maxScroll <= 0) return;
      var pct    = wrap.scrollLeft / maxScroll;
      var maxLeft = 100 - 40;
      thumb.style.left = (pct * maxLeft).toFixed(1) + '%';
    }
    wrap.addEventListener('scroll', syncThumb);

    var dragging = false, startX, startLeft;

    thumb.addEventListener('mousedown', function(e) {
      dragging  = true;
      startX    = e.clientX;
      startLeft = parseFloat(thumb.style.left) || 0;
      thumb.style.cursor = 'grabbing';
      e.preventDefault();
    });
    document.addEventListener('mousemove', function(e) {
      if (!dragging) return;
      var dx      = e.clientX - startX;
      var dpct    = dx / bar.offsetWidth * 100;
      var newLeft = Math.min(Math.max(startLeft + dpct, 0), 60);
      thumb.style.left  = newLeft + '%';
      wrap.scrollLeft   = (newLeft / 60) * (wrap.scrollWidth - wrap.clientWidth);
    });
    document.addEventListener('mouseup', function() {
      dragging = false;
      thumb.style.cursor = 'grab';
    });

    thumb.addEventListener('touchstart', function(e) {
      dragging  = true;
      startX    = e.touches[0].clientX;
      startLeft = parseFloat(thumb.style.left) || 0;
    }, { passive: true });
    document.addEventListener('touchmove', function(e) {
      if (!dragging) return;
      var dx      = e.touches[0].clientX - startX;
      var dpct    = dx / bar.offsetWidth * 100;
      var newLeft = Math.min(Math.max(startLeft + dpct, 0), 60);
      thumb.style.left  = newLeft + '%';
      wrap.scrollLeft   = (newLeft / 60) * (wrap.scrollWidth - wrap.clientWidth);
    }, { passive: true });
    document.addEventListener('touchend', function() { dragging = false; });

    syncThumb();
  })();

    // ─────────────────────────────────────────────────────────

  (function() {
    var track = document.getElementById('feat-track');
    var prev  = document.getElementById('feat-prev');
    var next  = document.getElementById('feat-next');
    if (!track || !prev || !next) return;
    var cards   = track.querySelectorAll('[data-feat-card]');
    var total   = cards.length;
    var current = 0;
    function goTo(index) {
      current = ((index % total) + total) % total;
      var cardWidth = cards[0].offsetWidth + 16;
      track.scrollTo({ left: current * cardWidth, behavior: 'smooth' });
    }
    next.onclick = function() { goTo(current + 1); };
    prev.onclick = function() { goTo(current - 1); };
  })();

    // ─────────────────────────────────────────────────────────

  /* ── SCROLL PROGRESS BAR ── */
    const bar = document.getElementById('scroll-progress');
    window.addEventListener('scroll', () => {
      const pct = window.scrollY / (document.body.scrollHeight - window.innerHeight) * 100;
      bar.style.width = pct + '%';
    }, { passive: true });

    /* ── INTERSECTION OBSERVER – SCROLL REVEAL ── */
    const revealObserver = new IntersectionObserver((entries) => {
      entries.forEach(entry => {
        if (entry.isIntersecting) {
          entry.target.classList.add('visible');
          revealObserver.unobserve(entry.target);
        }
      });
    }, { threshold: 0.12, rootMargin: '0px 0px -40px 0px' });

    document.querySelectorAll('.reveal').forEach(el => revealObserver.observe(el));

    /* ── COUNTER ANIMATION ── */
    function animateCounter(el) {
      const target = parseInt(el.dataset.target, 10);
      const suffix = el.querySelector('.stat-pct') ? '<span class="stat-pct">%<\/span>' : '';
      const duration = 1800;
      const start = performance.now();
      const update = (now) => {
        const elapsed = now - start;
        const progress = Math.min(elapsed / duration, 1);
        // ease out cubic
        const eased = 1 - Math.pow(1 - progress, 3);
        const current = Math.round(eased * target);
        el.innerHTML = current + suffix;
        if (progress < 1) requestAnimationFrame(update);
      };
      requestAnimationFrame(update);
    }

    const counterObserver = new IntersectionObserver((entries) => {
      entries.forEach(entry => {
        if (entry.isIntersecting) {
          const numEl = entry.target.querySelector('[data-target]');
          if (numEl) animateCounter(numEl);
          counterObserver.unobserve(entry.target);
        }
      });
    }, { threshold: 0.4 });

    document.querySelectorAll('.stat-item').forEach(el => counterObserver.observe(el));

    /* ── FEATURE CARD GLOW WHEN VISIBLE ── */
    const cardObserver = new IntersectionObserver((entries) => {
      entries.forEach(entry => {
        entry.target.classList.toggle('visible-card', entry.isIntersecting);
      });
    }, { threshold: 0.5 });

    document.querySelectorAll('.feature-card').forEach(el => cardObserver.observe(el));

    /* ── FAQ ACCORDION ── */
    function toggleFaq(btn) {
      window.toggleFaq = toggleFaq;
      const item = btn.closest('.faq-item');
      const isOpen = item.classList.contains('open');
      document.querySelectorAll('.faq-item.open').forEach(el => el.classList.remove('open'));
      if (!isOpen) item.classList.add('open');
    }

    /* ── HERO IMAGE SWITCHER (legacy stub, kept for safety) ── */
    function switchHero(src) { goToSlide(carouselImages.indexOf(src)); }

    /* ── BEFORE / AFTER — handled by inline <script> after the section ── */

    /* ══════════════════════════════════
       HERO CAROUSEL
    ══════════════════════════════════ */
    const carouselImages = [
      window.soneaxImages?.hero_gif || 'images/hero-gif.webp',
      window.soneaxImages?.img_1    || 'images/1.png',
      window.soneaxImages?.img_2    || 'images/2.png',
      window.soneaxImages?.img_3    || 'images/3.png',
      window.soneaxImages?.img_4    || 'images/4.png',
      window.soneaxImages?.img_5    || 'images/5.png',
      window.soneaxImages?.img_6    || 'images/6.png',
      window.soneaxImages?.img_7    || 'images/7.png',
      window.soneaxImages?.img_9    || 'images/9.png',
      window.soneaxImages?.img_10   || 'images/10.png',
      window.soneaxImages?.img_11   || 'images/11.png',
      window.soneaxImages?.img_12   || 'images/12.png',
      window.soneaxImages?.img_13   || 'images/13.png'
    ];
    const colorImageMap = {
      'white': window.soneaxImages?.bundle_white || 'images/3.png',
      'black': window.soneaxImages?.bundle_black || 'images/4.png',
      'pink':  window.soneaxImages?.bundle_pink  || 'images/5.png'
    };
    let currentIndex = 0;

    function initCarousel() {
      const thumbContainer = document.getElementById('carousel-thumbs');
      if (!thumbContainer) return;
      thumbContainer.innerHTML = '';
      carouselImages.forEach(function(src, i) {
        const img = document.createElement('img');
        img.src = src;
        img.className = 'carousel-thumb' + (i === 0 ? ' active' : '');
        img.onclick = function() { goToSlide(i); };
        thumbContainer.appendChild(img);
      });
      updateMainImage();
    }

    function goToSlide(index) {
      currentIndex = ((index % carouselImages.length) + carouselImages.length) % carouselImages.length;
      updateMainImage();
    }

    function carouselNext() { window.carouselNext = carouselNext; goToSlide(currentIndex + 1); }
    function carouselPrev() { window.carouselPrev = carouselPrev; goToSlide(currentIndex - 1); }

    function updateMainImage() {
      const mainImg = document.getElementById('carousel-main-img');
      if (mainImg) mainImg.src = carouselImages[currentIndex];
      document.querySelectorAll('.carousel-thumb').forEach(function(t, i) {
        t.classList.toggle('active', i === currentIndex);
      });
      const activeThumb = document.querySelectorAll('.carousel-thumb')[currentIndex];
      if (activeThumb) {
        activeThumb.scrollIntoView({ behavior: 'smooth', block: 'nearest', inline: 'center' });
      }
    }

    /* ══════════════════════════════════
       COLOR SELECTOR
    ══════════════════════════════════ */
    const colorNames  = { black: 'Black', white: 'White', pink: 'Pink Ribbon — Limited Edition' };
    const colorPrices = { black: 39,  white: 39,  pink: 45  };
    const colorOld    = { black: 79,  white: 79,  pink: 90  };

    function selectColor(color) {
      window.selectColor = selectColor;
      const price    = colorPrices[color];
      const original = colorOld[color];
      const savings  = 50;

      // Prix
      document.querySelectorAll('.price-current-display').forEach(function(el) { el.textContent = '£' + price; });
      document.querySelectorAll('.price-original-display').forEach(function(el) { el.textContent = '£' + original; });
      document.querySelectorAll('.price-save-display').forEach(function(el) { el.textContent = 'Save ' + savings + '%'; });

      // Nom couleur
      const nameDisplay = document.getElementById('color-name-display');
      if (nameDisplay) nameDisplay.textContent = colorNames[color] || color;

      // Boutons CTA
      document.querySelectorAll('.btn-add-cart').forEach(function(el) {
        el.textContent = 'Add to Cart — £' + price;
      });
      document.querySelectorAll('.btn-sticky-cart').forEach(function(el) {
        el.textContent = 'Add to Cart — £' + price;
      });
      const trialCta = document.getElementById('trial-cta-btn');
      if (trialCta) trialCta.textContent = 'Start My 30-Day Trial — £' + price;
      const stickyPrice = document.querySelector('.sticky-price');
      if (stickyPrice) stickyPrice.textContent = '£' + price;

      // Variant wrap borders
      ['black','white','pink'].forEach(function(c) {
        var w = document.getElementById('wrap-' + c);
        if (w) w.style.borderColor = 'transparent';
      });
      var activeWrap = document.getElementById('wrap-' + color);
      if (activeWrap) activeWrap.style.borderColor = '#3B2A6D';
    }

    // Init au chargement
    document.addEventListener('DOMContentLoaded', initCarousel);

    /* ══ COUNTDOWN TIMER ══ */
    (function() {
      var key = 'soneax_timer_end';
      var endTime = localStorage.getItem(key);
      if (!endTime) {
        endTime = Date.now() + (23 * 3600 + 47 * 60 + 12) * 1000;
        localStorage.setItem(key, endTime);
      }
      endTime = Number(endTime);
      function updateCountdown() {
        var remaining = Math.max(0, endTime - Date.now());
        var h = Math.floor(remaining / 3600000);
        var m = Math.floor((remaining % 3600000) / 60000);
        var s = Math.floor((remaining % 60000) / 1000);
        var pad = function(n) { return String(n).padStart(2, '0'); };
        var el = document.getElementById('countdown-display');
        if (el) el.textContent = pad(h) + ':' + pad(m) + ':' + pad(s);
        if (remaining > 0) {
          setTimeout(updateCountdown, 1000);
        } else {
          endTime = Date.now() + 24 * 3600000;
          localStorage.setItem(key, endTime);
          setTimeout(updateCountdown, 1000);
        }
      }
      updateCountdown();
    })();

    /* ══ PINK PROMO TIMER ══ */
    (function() {
      var pinkKey = 'soneax_pink_end';
      var pinkEnd = localStorage.getItem(pinkKey);
      if (!pinkEnd) {
        pinkEnd = Date.now() + 6 * 24 * 3600000;
        localStorage.setItem(pinkKey, pinkEnd);
      }
      pinkEnd = Number(pinkEnd);
      function updatePinkTimer() {
        var rem = Math.max(0, pinkEnd - Date.now());
        var d = Math.floor(rem / 86400000);
        var h = Math.floor((rem % 86400000) / 3600000);
        var m = Math.floor((rem % 3600000) / 60000);
        var pad = function(n) { return String(n).padStart(2, '0'); };
        var el = document.getElementById('pink-timer');
        if (el) el.textContent = d + 'd ' + pad(h) + 'h ' + pad(m) + 'm';
        if (rem > 0) setTimeout(updatePinkTimer, 60000);
      }
      updatePinkTimer();
    })();


    /* ══ LIVE VIEWERS ══ */
    (function() {
      function randomViewer() {
        var count = 42 + Math.floor(Math.random() * 20);
        var el = document.getElementById('live-count');
        if (el) el.textContent = count;
        setTimeout(randomViewer, 8000 + Math.random() * 12000);
      }
      setTimeout(randomViewer, 5000);
    })();

    /* ══ B/A CAROUSEL ARROWS — circulaire ══ */
    (function() {
      var track = document.getElementById('ba-carousel-track');
      var prev  = document.getElementById('ba-carousel-prev');
      var next  = document.getElementById('ba-carousel-next');
      if (!track || !prev || !next) return;
      var imgs    = track.querySelectorAll('img');
      var total   = imgs.length;
      var current = 0;
      function goTo(index) {
        current = ((index % total) + total) % total;
        var w = imgs[0].offsetWidth + 16;
        track.scrollTo({ left: current * w, behavior: 'smooth' });
      }
      next.addEventListener('click', function() { goTo(current + 1); });
      prev.addEventListener('click', function() { goTo(current - 1); });
    })();

    /* ── SMOOTH SCROLL ── */
    document.querySelectorAll('a[href^="#"]').forEach(a => {
      a.addEventListener('click', e => {
        const target = document.querySelector(a.getAttribute('href'));
        if (target) { e.preventDefault(); target.scrollIntoView({ behavior: 'smooth', block: 'start' }); }
      });
    });

    /* ── HEADER SHADOW ON SCROLL ── */
    const header = document.querySelector('header');
    window.addEventListener('scroll', () => {
      header.style.boxShadow = window.scrollY > 10
        ? '0 4px 24px rgba(108,63,197,0.10)'
        : 'none';
    }, { passive: true });

    /* ── PARALLAX TILT ON HERO IMAGE ── */
    const heroImg = document.querySelector('.hero-img-wrap');
    if (heroImg) {
      heroImg.addEventListener('mousemove', e => {
        const rect = heroImg.getBoundingClientRect();
        const x = (e.clientX - rect.left) / rect.width - 0.5;
        const y = (e.clientY - rect.top) / rect.height - 0.5;
        heroImg.style.transform = `perspective(800px) rotateY(${x * 8}deg) rotateX(${-y * 8}deg) translateY(0)`;
      });
      heroImg.addEventListener('mouseleave', () => {
        heroImg.style.transform = '';
      });
    }

  // ── Shopify Add to Cart (window.soneaxProductData) ──
  document.addEventListener('click', function(e) {
    var btn = e.target.closest('[data-add-to-cart]');
    if (!btn) return;
    e.preventDefault();
    e.stopPropagation();

    // 1. Upsells (chargeur, bonnet) → data-variant-id direct sur le bouton
    // 2. Produit principal → couleur via currentBundle → soneaxProductData
    var finalVariantId;
    var explicitId = btn.getAttribute('data-variant-id');
    if (explicitId && explicitId.length > 5) {
      finalVariantId = parseInt(explicitId, 10);
    } else {
      var color    = (typeof currentBundle !== 'undefined' && currentBundle) ? currentBundle : 'black';
      var variants = window.soneaxProductData && window.soneaxProductData.variants;
      var variant  = variants && (variants[color] || variants['black']);
      if (!variant) {
        console.error('[Soneax] No variant found for color:', color);
        return;
      }
      finalVariantId = parseInt(variant.id, 10);
    }
    if (!finalVariantId || isNaN(finalVariantId)) {
      console.error('[Soneax] Variant ID invalide:', explicitId);
      return;
    }

    var qty = 1;
    var qtySource = btn.getAttribute('data-qty-source');
    if (qtySource) {
      var qtyEl = document.getElementById(qtySource);
      if (qtyEl) qty = parseInt(qtyEl.textContent, 10) || 1;
    }

    var origHTML = btn.innerHTML;
    btn.innerHTML = '\u23F3 Adding...';
    btn.disabled  = true;

    fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ items: [{ id: finalVariantId, quantity: qty }] })
    })
    .then(function(res) { return res.json(); })
    .then(function() {
      btn.innerHTML = '\u2713 Added!';
      setTimeout(function() { btn.innerHTML = origHTML; btn.disabled = false; }, 1500);
      if (window.upcartOpenCart) window.upcartOpenCart();
      document.dispatchEvent(new CustomEvent('upcart:open'));
      document.dispatchEvent(new CustomEvent('cart:refresh'));
    })
    .catch(function(err) {
      console.error('[Soneax] Cart error:', err);
      btn.innerHTML = origHTML;
      btn.disabled  = false;
    });
  });

  // ═══ EXPOSE ALL FUNCTIONS GLOBALLY ═══
  window.selectBundle = selectBundle;
  window.changeQty    = changeQty;
  window.selectBonnet = selectBonnet;
  window.selectColor  = selectColor;
  window.toggleFaq    = toggleFaq;
  window.carouselNext = carouselNext;
  window.carouselPrev = carouselPrev;

  console.log('[Soneax] PDP JavaScript loaded successfully');
  console.log('[Soneax] Functions exposed:', {
    selectBundle: typeof window.selectBundle,
    changeQty:    typeof window.changeQty,
    selectBonnet: typeof window.selectBonnet,
    selectColor:  typeof window.selectColor,
    toggleFaq:    typeof window.toggleFaq,
    carouselNext: typeof window.carouselNext,
    carouselPrev: typeof window.carouselPrev
  });

} // end initSoneax
